module.exports = __webpack_public_path__ + "static/media/search-normal.1e51260b.svg";